import Input, { InputType } from "components/shared/inputs/input";
import { useFormContext } from "react-hook-form";
import useTranslation from "utils/hooks/useTranslation";
import { EtudeFormFields } from "../constants";

export const InstallationRestrictions: React.FC<{
  dataWidth: string;
  allData: any;
  calculate2: () => void;
  calculationTriggered?: boolean;
}> = ({ dataWidth, allData, calculate2, calculationTriggered }) => {
  const { t } = useTranslation();
  const { control } = useFormContext<EtudeFormFields>();

  const parseNumber = (val: any): number | undefined => {
    const n = Number(val);
    return isFinite(n) ? n : undefined;
  };

  const handleRecalcEvent = (e: React.KeyboardEvent | React.FocusEvent) => {
    if (!calculationTriggered) return; // disabled until first calculate2() run

    const target = e.target as HTMLInputElement;
    const value = parseNumber(target.value);

    const min =
      target.name === "largeur_porte"
        ? parseNumber(allData?.largeur_porte?.minimum)
        : parseNumber(allData?.hauteur_porte?.minimum);

    const max =
      target.name === "largeur_porte"
        ? parseNumber(allData?.largeur_porte?.maximum)
        : parseNumber(allData?.hauteur_porte?.maximum);

    const hadValueBefore = target.dataset.hadValue === "true";

    if (target.value !== "") {
      // If user typed a valid number, update the flag
      if (value !== undefined) {
        target.dataset.hadValue = "true";
      } else {
        // Invalid input, do nothing
        return;
      }

      // Only check bounds for actual numbers
      if (min !== undefined && value! < min) return;
      if (max !== undefined && value! > max) return;
    } else {
      // Input is empty
      if (!hadValueBefore) return; // if it was empty from start, do nothing
      target.dataset.hadValue = "false"; // reset after deletion
    }

    if ("key" in e) {
      // keyboard event
      if (e.key === "Enter") {
        e.preventDefault();
        calculate2();
      }
    } else if (e.type === "blur") {
      // focus/blur event
      calculate2();
    }
  };

  return (
    <group>
      <group
        data-gap="10"
        data-space="10"
        data-background="accent-xtralight"
        data-radius="10"
        data-width={dataWidth}
        data-direction="column"
      >
        <group data-align="center" data-width="auto">
          {" "}
          <text
            data-weight="600"
            data-text-size="17"
            data-ellipsis=""
            data-color="grey-color-dark"
            data-space-horizontal="10"
          >
            {t("FO_SIMULATION_INSTALLATION_RESTRICTIONS")}
          </text>{" "}
        </group>
        <group data-gap="30">
          <Input
            dataLength="400"
            label="FO_SOL_WIDTH"
            type={InputType.Number}
            name="largeur_porte"
            control={control}
            helpText={t("FO_HELP_MINI_WIDTH")}
            unit="mm"
            minValue={allData?.largeur_porte?.minimum}
            maxValue={allData?.largeur_porte?.maximum}
            onBlur={handleRecalcEvent}
            onKeyDown={handleRecalcEvent}
          />
          <Input
            dataLength="400"
            label="FO_SOL_HEIGHT"
            type={InputType.Number}
            name="hauteur_porte"
            control={control}
            helpText={t("FO_HELP_MINI_HEIGHT")}
            unit="mm"
            minValue={allData?.hauteur_porte?.minimum}
            maxValue={allData?.hauteur_porte?.maximum}
            onBlur={handleRecalcEvent}
            onKeyDown={handleRecalcEvent}
          />
        </group>
      </group>
    </group>
  );
};
